import React, { useEffect } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import BlogBannerContainer from './BlogBannerContainer';
import BlogBodyContainer from './BlogBodyContainer';
//fixes
export default function BlogComponent(props) {
  return (
    <main className="main">
      <BlogBannerContainer full={props.full} />
      <BlogBodyContainer
        full={props.full}
        story={props.story}
        stories={props.stories}
        sidebar={props.sidebar}
      />
    </main>
  );
}
